export default __webpack_public_path__ + "static/media/success.72a27ea3.gif";